import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react'
import { ScrollView } from 'react-native'

interface AutocompleteInputContextValue {
  registerScrollView: (ref: ScrollView) => void
  unregisterScrollView: () => void
  setIsDropdownOpened: (isOpened: boolean) => void
  isDropdownOpened: boolean
  setScreenTop: (top: number) => void
  screenTop?: number
  hasContext: boolean
}

const AutocompleteInputContext = createContext<AutocompleteInputContextValue | null>(null)

export const useAutocompleteInputContext = () =>
  useContext(AutocompleteInputContext) ?? {
    registerScrollView: () => {},
    unregisterScrollView: () => {},
    setIsDropdownOpened: () => {},
    isDropdownOpened: false,
    setScreenTop: () => {},
    screenTop: undefined,
    hasContext: false,
  }

export const AutocompleteInputProvider = ({ children }: { children: React.ReactNode }) => {
  const scrollViewRef = useRef<ScrollView | null>(null)
  const [isDropdownOpened, setIsDropdownOpened] = useState(false)
  const [screenTop, setScreenTop] = useState<number>()

  const registerScrollView = useCallback((ref: ScrollView) => {
    scrollViewRef.current = ref
  }, [])

  const unregisterScrollView = useCallback(() => {
    scrollViewRef.current = null
  }, [])

  const value = useMemo((): AutocompleteInputContextValue => {
    return {
      registerScrollView,
      unregisterScrollView,
      isDropdownOpened,
      setIsDropdownOpened,
      screenTop,
      setScreenTop,
      hasContext: true,
    }
  }, [isDropdownOpened, registerScrollView, screenTop, unregisterScrollView])
  return (
    <AutocompleteInputContext.Provider value={value}>{children}</AutocompleteInputContext.Provider>
  )
}
